<template>
  <div class="activity-my-ticket">
    <!-- 活动信息 -->
    <div class="a-info">
      <a
        class="a-info-wrap"
        :href="`/live/m/ActDetail?zbid=${$route.query.zbid}&actid=${
          $route.query.actid
        }${
          $route.query.invitationUserId
            ? '&invitationUserId=' + $route.query.invitationUserId
            : ''
        }`"
      >
        <div class="a-cover">
          <span class="a-activity-status">{{ activity.SignUpStatusName }}</span>
          <img :src="activity.Poster" :alt="activity.Name" />
        </div>
        <div class="a-content">
          <div class="a-title">{{ activity.Name }}</div>
          <div class="a-address">{{ activity.Address }}</div>
          <div class="a-time">{{ activityTime }}</div>
        </div>
      </a>
      <a
        class="a-report"
        :href="`/live/WXComplaint?ctype=4&fromtype=0&id=${$route.query.actid}`"
      >
        问题反馈
      </a>
    </div>

    <!-- 票券列表 -->
    <div class="a-ticket-list">
      <div class="a-ticket" v-for="(ticket, index) in list" :key="index">
        <van-checkbox
          v-if="selectTicket"
          v-model="ticket.checked"
          :disabled="ticket.disabled || !IsCanShare(ticket.IsShare)"
          style="padding-right: 15px"
        ></van-checkbox>
        <div
          class="a-ticket-item"
          :class="selectTicket && !IsCanShare(ticket.IsShare) ? 'no-share' : ''"
        >
          <span
            :class="{
              'a-status': true,
              'a-wait-examine': /3/.test(ticket.SignUpStatus),
              'a-signined':
                /7/.test(ticket.SignUpStatus) ||
                /6/.test(ticket.SignInStatus) ||
                (ticket.SignInStatus == 1 && ticket.SignUpStatus == 1),
              'a-reject': /0|4/.test(ticket.SignUpStatus),
            }"
            :data-text="
              ticket.SignUpStatus === 1
                ? ticket.SignInStatusName
                : ticket.SignUpStatusName
            "
          ></span>
          <div class="a-ticket-body">
            <div class="a-ticket-info">
              <div class="a-name">{{ ticket.Name }}</div>
              <div class="a-code">票号：{{ ticket.TicketNo }}</div>
            </div>
            <span class="a-price">
              {{ ticket.PriceName ? ticket.PriceName : '￥' + ticket.Price }}
            </span>
          </div>
          <div class="a-form-item">
            <span class="a-label">手机号码</span>
            <span class="a-value">{{ ticket.UserPhone }}</span>
          </div>
          <div class="a-form-item">
            <span class="a-label">用户名</span>
            <span class="a-value">{{ ticket.UserName }}</span>
          </div>
          <div class="a-form-item">
            <span class="a-label">报名时间</span>
            <span class="a-value">{{ ticket.SignUpTime }}</span>
          </div>
          <div
            class="a-share-tips"
            v-if="selectTicket && !IsCanShare(ticket.IsShare)"
          >
            <p>当前票券不支持转赠</p>
          </div>
        </div>
      </div>
      <p class="load-all-tips" v-if="list.length === 0">没有相关的票哦~</p>
      <p class="load-all-tips" v-else>已经加载全部</p>
    </div>

    <!-- 弹窗* 社群 -->
    <van-overlay
      :show="showCoummunity"
      @click="showCoummunity = false"
      style="z-index: 9999 !important"
    >
      <div @click.stop class="showCoummunity-popup">
        <div class="a-title">{{ activity.GroupContent }}</div>
        <div class="a-coummunity">
          <img class="a-qr-code" :src="activity.GroupQRCode" alt="" />
          <p class="a-desc">长按群二维码，识别并加入</p>
        </div>
        <div class="a-menu">
          <div class="a-menu-item" v-for="(i, index) in menuList" :key="index">
            <img class="a-icon" :src="i.icon" alt="" />
            <p class="a-name">{{ i.name }}</p>
          </div>
        </div>
      </div>
    </van-overlay>

    <!-- 底栏 -->
    <div class="a-bottom-area">
      <div class="a-share-tips">
        <template>
          <p>朋友成功领取后，票券所有权将转让，请确定无误后再进行分享</p>
          <p>（仅待签到票券允许分享）</p>
        </template>
      </div>
      <div class="a-bottom-bar">
        <span
          v-if="activity.IsShowGroup && !selectTicket"
          class="a-join-btn"
          @click="handleJoinCommunity"
        >
          加入社群
        </span>
        <template v-if="selectTicket">
          <span class="a-back-btn" @click="handleCancelSelect">取消</span>
          <span class="a-select-all-btn" @click="handleSelectAllTicket">
            全选
          </span>
        </template>
        <span
          v-if="$route.query.jumpType === 'signup'"
          class="a-btn"
          @click="handleSignUp"
        >
          签到
        </span>
        <template v-else>
          <span class="a-btn" @click="handleShareTicket"> 转赠票券 </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getmyactticketlist,
  inspectuserpaymentasync,
  // getshareticlist,
  getnotsigninlist,
} from '@/utils/http/modules/ticketing/ticketing.request'
export default {
  name: 'ActivityMyTicket',
  data() {
    return {
      enc_id: this.$route.query.enc_id,
      allList: [],
      activity: {},
      activityTime: '00:00',
      selectTicket: false,
      showCoummunity: false,
      notSignList: [],
      menuList: [
        {
          icon: 'https://static2.sinsam.com/zhibo/livecontent/img/activity/icon-news.png',
          name: '活动最新消息',
        },
        {
          icon: 'https://static2.sinsam.com/zhibo/livecontent/img/activity/icon-chat.png',
          name: '同行经验交流',
        },
        {
          icon: 'https://static2.sinsam.com/zhibo/livecontent/img/activity/icon-activity.png',
          name: '社群运营活动',
        },
      ],
    }
  },
  computed: {
    list() {
      if (this.selectTicket) {
        return this.notSignList
      } else {
        return this.allList
      }
    },
  },
  methods: {
    // 获取我的票券列表
    async getData() {
      try {
        const params = {
          zbId: this.$route.query.zbid,
          actid: this.$route.query.actid,
          userid: window.userInfo.id,
          datatype: 'getMyTicList',
          pageIndex: 1,
          pageSize: 999,
          signInStatus: -1,
          SignUpStatus: 9,
          SignUpIdList: !this.$route.query.signUpIdList
            ? undefined
            : this.$route.query.signUpIdList.split(','),
        }
        const res = await getmyactticketlist(params)
        console.log('获取列表', res)
        if (res.isok) {
          this.activity = JSON.parse(JSON.stringify(res.dataObj))

          this.activityTime = this.activity
            ? this.formatActTime(this.activity.StartTime, this.activity.EndTime)
            : '00:00'
          this.allList = this.activity.TicketInfo.map(item => {
            return {
              ...item,
              checked: false,
              disabled: false,
            }
          })
        }
      } catch (err) {
        console.error(err)
      }
    },
    // 检测是否有未支付订单
    async getEncId() {
      if (this.enc_id) return
      try {
        const params = {
          actId: this.$route.query.actid,
          userId: window.userInfo.id,
        }
        const res = await inspectuserpaymentasync(params)
        if (res.isok) {
          this.enc_id = res.dataObj.EncUserId
        }
      } catch (err) {
        console.error(err)
      }
    },
    // 获取分享列表
    async getShareList() {
      try {
        const params = {
          zbId: this.$route.query.zbid,
          actid: this.$route.query.actid,
          userid: window.userInfo.id,
          datatype: 'getMyTicList',
          pageIndex: 1,
          pageSize: 99,
          signInStatus: 0,
          signUpStatus: 1,
        }
        const res = await getnotsigninlist(params)
        if (res.isok) {
          console.log(res)
          this.activity = JSON.parse(JSON.stringify(res.dataObj))

          this.activityTime = this.formatActTime(
            this.activity.StartTime,
            this.activity.EndTime
          )
          this.notSignList = this.activity.TicketInfo.map(item => {
            return {
              ...item,
              checked: false,
              disabled: false,
            }
          })
          // if (this.$route.query.jumpType !== 'signup') {
          //   this.notSignList = this.notSignList.filter(item => item.IsShare)
          // }
        }
      } catch (err) {
        console.error(err)
      }
    },
    // 加入社群
    handleJoinCommunity() {
      this.showCoummunity = true
    },
    // 取消分享
    async handleCancelSelect() {
      this.allList = await this.allList.map(item => {
        return {
          ...item,
          checked: false,
        }
      })

      this.selectTicket = false
    },
    // 全选票券
    handleSelectAllTicket() {
      const isSomeNotSelect = this.notSignList.some(
        item => !item.checked && this.IsCanShare(item.IsShare)
      )
      console.log(isSomeNotSelect)
      if (isSomeNotSelect) {
        this.notSignList = this.notSignList.map(item => {
          return {
            ...item,
            checked: this.IsCanShare(item.IsShare) ? true : false,
          }
        })
      }
      if (this.notSignList.filter(f => f.checked).length) {
        const totalNum = this.notSignList.filter(f => f.checked).length
        this.$toast(`已选中${totalNum}张`)
      }
    },

    // 筛选可操作的
    handleSelectOperable() {
      this.selectTicket = !this.selectTicket
    },

    // 确认分享
    handleShareTicket() {
      if (this.selectTicket) {
        const selectList = this.list.filter(item => item.checked)
        if (!selectList.length) {
          this.$toast('请选中需要转赠的票券')
          return
        }

        const signUpList = selectList.map(item => item.Id).join(',')
        console.log('选中的票券:', selectList, signUpList)

        this.$router.replace({
          path: `/ActShareTicket`,
          query: {
            zbid: this.$route.query.zbid,
            actid: this.$route.query.actid,
            invitationUserId: this.$route.query.invitationUserId,
            enc_id: this.enc_id,
            signUpList: signUpList,
          },
        })
      }
      this.selectTicket = true
      this.getShareList()
    },

    // 签到
    handleSignUp() {
      if (this.selectTicket) {
        const selectList = this.list.filter(item => item.checked)
        if (!selectList.length) {
          this.$toast('请选择要签到的票项')
          return
        }

        const signUpList = selectList.map(item => item.Id).join(',')
        console.log('选中的票券:', selectList, signUpList)

        this.$router.replace({
          path: `/ActSignIn`,
          query: {
            zbid: this.$route.query.zbid,
            actid: this.$route.query.actid,
            invitationUserId: this.$route.query.invitationUserId,
            // enc_id: this.enc_id,
            signUpList: signUpList,
          },
        })
      }
      this.selectTicket = true
      this.getShareList()
      // this.$router.push({
      //   path: `/ActSignIn`,
      //   query: {
      //     zbid: this.$route.query.zbid,
      //     actid: this.$route.query.actid,
      //     signUpList: 669479
      //   }
      // })
    },

    // 格式化活动时间，
    formatActTime(StartTime, EndTime) {
      const isIOS = /iPhone/g.test(navigator.userAgent)
      // 格式化单位数字
      function formatNumber(n) {
        n = n.toString()
        return n[1] ? n : '0' + n
      }
      if (isIOS) {
        StartTime = StartTime.replace(/-/g, '/')
        EndTime = EndTime.replace(/-/g, '/')
      }
      var st = new Date(StartTime)
      var ed = new Date(EndTime)
      var nt = new Date()
      var timeStr = ''
      if (st.getFullYear() !== ed.getFullYear()) {
        return StartTime + ' - ' + EndTime
      } else if (ed.getFullYear() !== nt.getFullYear()) {
        return StartTime + ' - ' + EndTime
      }
      if (st.getMonth() !== ed.getMonth() || st.getDate() !== ed.getDate()) {
        var st_timeStr =
          st.getMonth() +
          1 +
          '月' +
          st.getDate() +
          '日 ' +
          formatNumber(st.getHours()) +
          ':' +
          formatNumber(st.getMinutes())
        var ed_timeStr =
          ed.getMonth() +
          1 +
          '月' +
          ed.getDate() +
          '日 ' +
          formatNumber(ed.getHours()) +
          ':' +
          formatNumber(ed.getMinutes())
        return st_timeStr + ' - ' + ed_timeStr
      } else {
        timeStr = st.getMonth() + 1 + '月' + st.getDate() + '日 '
        var stt =
          formatNumber(st.getHours()) + ':' + formatNumber(st.getMinutes())
        var edt =
          formatNumber(ed.getHours()) + ':' + formatNumber(ed.getMinutes())
        return timeStr + ' ' + stt + ' - ' + edt
      }
    },
    // 是否可分享（只增对转赠时判断）
    IsCanShare(ishare) {
      if (this.$route.query.jumpType == 'signup' || ishare) {
        return true
      } else {
        return false
      }
    },
  },
  async mounted() {
    await this.getEncId()
    await this.getData()
    if (this.$route.query.jumpType === 'signup') {
      // 待签到列表
      const list = this.activity.TicketInfo.filter(item => {
        return item.SignInStatus === 0 && item.SignUpStatus === 1
      })

      // 有且仅有一张票时，直接签到
      if (list && list.length === 1 && list[0]) {
        const signUpList = list[0].Id
        this.$router.replace({
          path: `/ActSignIn`,
          query: {
            zbid: this.$route.query.zbid,
            actid: this.$route.query.actid,
            invitationUserId: this.$route.query.invitationUserId,
            signUpList: signUpList,
          },
        })
        return
      } else if (list && !list.length) {
        this.$router.push({
          path: `/ActDetail`,
          query: {
            zbid: this.$route.query.zbid,
            actid: this.$route.query.actid,
            invitationUserId: this.$route.query.invitationUserId,
          },
        })
        return
      }
    }
    this.getShareList()
  },
}
</script>

<style lang="scss" scpoed>
.activity-my-ticket {
  background: #f6f6f6;
  display: flex;
  flex-direction: column;
  .a-info {
    flex-shrink: 0;
    background: #ffffff;
    padding: 15px;
    margin-bottom: 5px;
    .a-report {
      margin-top: 20px;
      display: block;
      color: #0083ff;
      text-align: center;
      font-size: 14px;
    }
    .a-info-wrap {
      display: flex;
      .a-cover {
        width: 148px;
        height: 83px;
        border-radius: 2px;
        overflow: hidden;
        flex: 0 0 148px;
        position: relative;
        .a-activity-status {
          position: absolute;
          top: 5px;
          left: 5px;
          padding: 4px 6px;
          height: 15px;
          line-height: 15px;
          text-align: center;
          background: linear-gradient(0deg, #0084ff, #2eaeff);
          border-radius: 2px;
          font-size: 10px;
          color: white;
        }
        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
      }
      .a-content {
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        padding-left: 10px;
        .a-title {
          font-size: 14px;
          font-weight: bold;
          color: #262626;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .a-address {
          font-size: 12px;
          color: #353535;
          line-height: 15px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .a-time {
          font-size: 12px;
          color: #747474;
          line-height: 15px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .a-ticket-list {
    margin: 15px 15px 55px;
    .a-ticket {
      display: flex;
    }
    .a-ticket-item {
      flex: 1;
      border-radius: 5px;
      background: #ffffff;
      padding: 10px 20px 10px 20px;
      box-sizing: border-box;
      margin-bottom: 10px;
      position: relative;
      overflow: hidden;
      &.no-share {
        padding-bottom: 26px;
      }
      // 常规状态
      .a-status {
        position: absolute;
        top: -50px;
        right: -46px;
        width: 0px;
        height: 0;
        border: 46px solid #0084ff;
        border-color: transparent #0084ff transparent transparent;
        transform: rotate(135deg);
        &::before {
          content: attr(data-text);
          position: absolute;
          top: -10px;
          left: 10px;
          color: #fff;
          font-size: 12px;
          width: 50px;
          text-align: center;
          height: 14px;
          transform: rotate(-88deg);
        }
      }
      // 已签到
      .a-signined {
        border-color: rgba(0, 132, 255, 0.1);
        &::before {
          color: #0084ff;
        }
      }
      // 待审核
      .a-wait-examine {
        border-color: rgba(255, 0, 98, 0.1);
        &::before {
          color: #ff0062;
        }
      }
      // 已拒绝
      .a-reject {
        border-color: rgba(5, 5, 5, 0.1);
        &::before {
          color: #050505;
        }
      }
      .a-ticket-body {
        height: 75px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #f5f6f7;
        .a-ticket-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          .a-name {
            line-height: 18px;
            padding-top: 5px;
            height: 35px;
            color: #353535;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 16px;
          }
          .a-code {
            color: #747474;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            line-height: 22px;
            font-size: 12px;
          }
        }
        .a-price {
          align-self: flex-end;
          display: flex;
          padding-bottom: 10px;
          color: #0083ff;
          font-weight: bold;
          font-size: 22px;
        }
      }
      .a-form-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: #747474;
        height: 40px;
        line-height: 40px;
        .a-label {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #747474;
          line-height: 15px;
        }
        .a-value {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #353535;
          line-height: 15px;
        }
      }
      .a-share-tips {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: center;
        font-size: 12px;
        background: #fceac2;
        color: #794315;
        padding: 6px 8px;
      }
    }
  }
  .load-all-tips {
    line-height: 40px;
    height: 40px;
    color: #747474;
    text-align: center;
    font-size: 14px;
  }
  .a-bottom-area {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    // z-index: 999;
    width: 100%;
    .a-share-tips {
      text-align: center;
      font-size: 12px;
      background: #fceac2;
      color: #794315;
      padding: 5px 8px;
      & > p:first-child {
        margin-bottom: 5px;
      }
    }
    .a-bottom-bar {
      flex-shrink: 0;
      height: 55px;
      background: #ffffff;
      box-sizing: border-box;
      padding: 5px 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #f6f7f8;
      height: calc(55px + env(safe-area-inset-bottom));
      padding-bottom: calc(5px + env(safe-area-inset-bottom));
      .a-total {
        margin-right: 10px;
        color: #0083ff;
        font-size: 14px;
      }
      .a-btn {
        flex: 1;
        height: 40px;
        background: #0084ff;
        border: 1px solid #0084ff;
        line-height: 40px;
        text-align: center;
        border-radius: 2px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #ffffff;
      }
      .a-btn-disabled {
        flex: 1;
        height: 40px;
        background: #0084ff;
        border: 1px solid #0084ff;
        line-height: 40px;
        text-align: center;
        border-radius: 2px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #ffffff;
        opacity: 0.5;
      }
      .a-join-btn {
        background: #fceac2 !important;
        color: #794315 !important;
        border: 1px solid #f9dea2 !important;
        display: block;
        line-height: 0.4rem;
        text-align: center;
        font-size: 0.14rem;
        font-family: PingFang SC;
        padding: 0 15px;
        margin-right: 10px;
        font-weight: normal;
      }
      .a-back-btn {
        background: #fceac2 !important;
        color: #794315 !important;
        border: 1px solid #f9dea2 !important;
        display: block;
        line-height: 0.4rem;
        text-align: center;
        font-size: 0.14rem;
        font-family: PingFang SC;
        padding: 0 15px;
        font-weight: normal;
        margin-right: 4px;
      }
      .a-select-all-btn {
        background: rgba(0, 132, 255, 0.1) !important;
        border-color: rgba(0, 132, 255, 0.1) !important;
        color: #0084ff !important;
        display: block;
        line-height: 0.4rem;
        text-align: center;
        font-size: 0.14rem;
        font-family: PingFang SC;
        padding: 0 15px;
        font-weight: normal;
        margin-right: 4px;
      }
    }
  }

  // 加入社群
  .showCoummunity-popup {
    background: rgb(255, 255, 255);
    width: 82.67%;
    box-sizing: border-box;
    margin: auto;
    top: 50%;
    position: relative;
    transform: translate3d(0, -50%, 0);
    padding: 15px 20px 30px;
    border-radius: 20px;
    overflow: hidden;
    .a-title {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #000000;
      line-height: 20px;
      word-break: break-all;
      text-align: center;
    }
    .a-coummunity {
      margin: 20px 0 30px;
      text-align: center;
      user-select: none;
      .a-qr-code {
        width: 130px;
        height: 130px;
        vertical-align: bottom;
      }
      .a-desc {
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #747474;
      }
    }
    .a-menu {
      display: flex;
      justify-content: space-between;
      align-items: center;
      user-select: none;
      .a-menu-item {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .a-icon {
          width: 50px;
          height: 50px;
        }
        .a-name {
          margin-top: 5px;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #353535;
          line-height: 12px;
        }
      }
    }
  }
}
</style>
